import { Component, HostListener } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'mercury-ui';
  isIframe = false;

  constructor(private msalService: MsalService){
    this.isIframe = window !== window.parent && !window.opener;
  }

  @HostListener('window:unload', [ '$event' ])
  unloadHandler() {
    this.msalService.logout();
  }

}
